import { UrlStructureFactory } from "@factory/UrlStructureFactory";

import { URLStructureType_pageCollection_items } from "globalQueries/contentfulTypes/URLStructureType";
import { UrlStructureItem } from "types/UrlStructureItem";

export const mappedUrlStructure = (
  items: Array<URLStructureType_pageCollection_items>,
  startPageId: string,
): UrlStructureItem[] => {
  return items?.length ? UrlStructureFactory(items, startPageId) : ({} as UrlStructureItem[]);
};
